module.exports = __webpack_public_path__ + "img/MV.1be5104f.svg";